<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header>
            <div class="logo">
              <router-link :to="{ name: 'Home'}" title="Homepage"><img src="../img/logo.png" alt="Re Shaping"/></router-link>
            </div>

            <!-- NAV -->
            <input type="checkbox" id="boton" aria-label="menu">
            <div id="menuToggle"> </div>
            <nav aria-label="Main Navigation">
            <ul class="menu">
              <li class="home">
                <router-link :to="{ name: 'Home'}" title="Homepage">Home</router-link>
              </li>
              <li class="population-identification">
                <router-link :to="{ name: 'PopulationIdentificationProcesses'}" title="Population Identification Processes">Population Identification <br>Processes</router-link>
              </li>
              <li class="expanding-capabilities">
                <router-link :to="{ name: 'ExpandingInternalAwareness'}" title="Expanding Internal Awareness">Expanding Internal <br>Awareness</router-link>
              </li>
              <li class="collaborative-care">
                <router-link :to="{ name: 'CollaborativeCareResources'}" title="Collaborative Care Resources">Collaborative Care <br>Resources</router-link>
              </li>
              <li class="process-evaluation">
                <router-link :to="{ name: 'ProcessEvaluation'}" title="Process Evaluation">Process <br>Evaluation</router-link>
              </li>
              <li class="resource-library">
                <router-link :to="{ name: 'ResourceLibrary'}" title="Resource Library">Resource <br>Library</router-link>
              </li>
              <li class="site-guide">
                <router-link :to="{ name: 'SiteGuide'}" title="Site Guide ReShaping">Site Guide</router-link>
              </li>
            </ul>
            </nav>
            <!-- NAV -->
          </header>
          <h1>Privacy Policy</h1>
        </div>
      </div>
    </div>

    <div class="body">
      <p class="subhead upper">
        Supplemental Privacy Notices
      </p>
      <p>
        <a href="#pncr">
          Privacy Notice for California Residents
        </a>
      </p>
      <p>
        <a href="#pnnr">
          Privacy Notice for Nevada Residents
        </a>
      </p>

      <p>
        <strong>Janssen Pharmaceuticals, Inc.</strong> respects your privacy and wants you to be familiar with how we collect, use, and disclose information. This Privacy Policy describes our practices in connection with information that we or our service providers collect through the website or application (hereinafter the <strong>“Service”</strong>) operated and controlled by us from which you are accessing this Privacy Policy. We encourage you to read the full Privacy Policy before using this Service or providing any personal information. By providing personal information to us or by using the Service, you acknowledge that you have read and understand this Privacy Policy.
      </p>
      <p>
        <strong class="upper">Use by Minors</strong>
      </p>
      <p>
        The Service is not directed to individuals under the age of 18, and we request that these individuals not provide personal information through the Service. If your child has submitted Personal Information and you would like to request that such Personal Information be removed, please contact us as explained below under “Contacting Us.”
      </p>
      <p>
        <strong class="upper">Information Collection</strong>
      </p>
      <p>
        We may ask you to submit personal information in order for you to benefit from certain features (such as newsletter subscriptions, tips/pointers, or order processing) or to participate in a particular activity (such as sweepstakes or other promotions). You will be informed what information is required and what information is optional.
      </p>
      <p>
        We may combine the information you submit with other information we have collected from you, whether on or offline, including, for example, your purchase history. We may also combine it with information we receive about you from other sources, such as other Johnson &amp; Johnson Affiliates, publicly available information sources (including information from your publicly available social media profiles), and other third-party information providers.
      </p>
      <p>
        If you submit any personal information relating to another individual to us, you represent that you have the authority to do so and to permit us to use the information in accordance with this Privacy Policy.
      </p>
      <p>
        <strong class="upper">Sensitive Information</strong>
      </p>
      <p>
        Unless we specifically request or invite it, we ask that you not send us, and you not disclose, any sensitive personal information (e.g., Social Security numbers, information related to racial or ethnic origin, political opinions, religion or philosophical beliefs, health or medical condition, sex life or sexual orientation, criminal background, or trade union membership, or biometric or genetic data) on or through the Service or otherwise directly to us.
      </p>
      <p>
        <strong class="upper">Automatic Information Collection and Use</strong>
      </p>
      <p>
        We and our service providers may automatically collect and use information in the following ways as you navigate around the Service:
      </p>
      <div class="indent">
        <p>
          <strong>Through your browser:</strong> Certain information is collected by most browsers, such as your Media Access Control (MAC) address, computer type (Windows or Mac), screen resolution, operating system name and version, and Internet browser type and version. We may collect similar information, such as your device type and identifier, if you access the Service through a mobile device. We use this information to ensure that the Service functions properly.
        </p>
        <p>
          <strong>Using cookies:</strong> Cookies are pieces of information stored directly on the computer you are using. Cookies allow us to collect information such as browser type, time spent on the Service, pages visited, and language preferences. We and our service providers use the information for security purposes, to facilitate navigation, display information more effectively, and to personalize your experience while using the Service. We also use cookies to recognize your computer or device, which makes your use of the Service easier, such as to remember what is in your shopping cart. In addition, we use cookies to gather statistical information about Service usage in order to continually improve its design and functionality, understand how individuals use it, and to assist us with resolving questions regarding it. Cookies further allow us to select which of our advertisements or offers are most likely to appeal to you and display them while you are on the Service. We may also use cookies in online advertising to track consumer responses to our advertisements.
        </p>
        <p>
          You can refuse to accept these cookies by following your browser’s instructions; however, if you do not accept them, you may experience some inconvenience in your use of the Service. You may also not receive advertising or other offers from us that are relevant to your interests and needs. To learn more about cookies, please visit <a href="http://www.allaboutcookies.org" target="_blank"> http://www.allaboutcookies.org</a>.
        </p>
        <p>
          <strong>Using Flash cookies:</strong> Our use of Adobe Flash technology (including Flash Local Stored Objects (“Flash LSOs”)) allows us to, among other things, serve you with more tailored information, facilitate your ongoing access to and use of the Service, and collect and store information about your use of the Service. If you do not want Flash LSOs stored on your computer, you can adjust the settings of your Flash player to block Flash LSO storage using the tools contained in the <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html" target="_blank">Website Storage Settings Panel</a>. You can also control Flash LSOs by going to the <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html" target="_blank">Global Storage Settings Panel</a> and following the instructions. Please note that setting the Flash Player to restrict or limit acceptance of Flash LSOs may reduce or impede the functionality of some Flash applications.
        </p>
        <p>
          <strong>Using pixel tags, web beacons, clear GIFs, or other similar technologies:</strong> Certain information is collected by most browsers, such as your Media Access Control (MAC) address, computer type (Windows or Mac), screen resolution, operating system name and version, and Internet browser type and version. We may collect similar information, such as your device type and identifier, if you access the Service through a mobile device. We use this information to ensure that the Service functions properly.
        </p>
        <p>
          <strong>Interest-based advertising:</strong> We may use third-party advertising companies to serve advertisements regarding goods and services. that may be of interest to you when you access and use the Service and other online services, based on information relating to your access and use of the Service and other online services on any of your devices. To do so, these companies may place or recognize a unique cookie on your browser (including through the use of pixel tags). They may also use these technologies, along with information they collect about your online use, to recognize you across the devices you use, such as a mobile phone and a laptop.
        </p>
        <p>
          If you would like more information about this practice, and to learn how to opt-out of it, in desktop and mobile browsers on the particular device on which you are accessing this Privacy Policy, please visit <a href="http://optout.aboutads.info/#/" target="_blank">http://optout.aboutads.info/#/</a> and <a href="http://optout.networkadvertising.org/#/" target="_blank">http://optout.networkadvertising.org/#/</a>. You may download the AppChoices app at <a href="http://www.aboutads.info/appchoices" target="_blank">http://www.aboutads.info/appchoices</a> to opt-out in mobile apps.
        </p>
        <p>
          <strong>IP address:</strong> Your IP address is a number that is automatically assigned to your computer by your Internet Service Provider. An IP address is identified and logged automatically in our server log files whenever a user visits the Service, along with the time of the visit and the pages visited. Collecting IP addresses is standard practice and is done automatically by many online services. We use IP addresses for purposes such as calculating Service usage levels, diagnosing server problems, and administering the Service. We may also derive your approximate location from your IP address.
        </p>
        <p>
          <strong>Device Information:</strong> We may collect information about your mobile device, such as a unique device identifier, to understand how you use the Service.
        </p>
      </div>
      <p>
        <strong class="upper">How We Use and Disclose Information</strong>
      </p>
      <p>
        We use and disclose information you provide to us as described to you at the point of collection. Please see the section entitled "Choices and Access" below to learn how you may opt-out of certain of our uses and disclosures.
      </p>
      <p>
        Where required by applicable law, we will obtain your consent to our use of your personal information at the point of information collection. We may also rely on other legal bases, specifically for:
      </p>

      <div>
        <strong>Providing the functionality of the Service and fulfilling your requests.</strong>
        <ul>
          <li>
            to provide the functionality of the Service to you and providing you with related customer service;
          </li>
          <li>
            to respond to your inquiries and fulfill your requests, such as to send you documents you request or to e-mail alerts;
          </li>
          <li>
            to send you important information regarding our relationship with you or regarding the Service, changes to our terms, conditions, and policies and/or other administrative information.
          </li>
        </ul>
        <p>
          We will engage in these activities to manage our contractual relationship with you and/or to comply with a legal obligation.
        </p>


        <strong>Accomplishing our business purposes.</strong>
        <ul>
          <li>
            for data analysis, for example, to improve the efficiency of the Service;
          </li>
          <li>
            for audits, to verify that our internal processes function as intended and are compliant with legal, regulatory, or contractual requirements;
          </li>
          <li>
            for fraud and security monitoring purposes, for example, to detect and prevent cyberattacks or attempts to commit identity theft;
          </li>
          <li>
            for developing new products and services;
          </li>
          <li>
            for enhancing, improving or modifying our website or products and services;
          </li>
          <li>
            for identifying Service usage trends, for example, understanding which parts of our Service are of most interest to users; and
          </li>
          <li>
            for determining the effectiveness of our promotional campaigns so that we can adapt our campaigns to the needs and interests of our users.
          </li>
        </ul>

        <p>
          We will engage in these activities to manage our contractual relationship with you, to comply with a legal obligation, and/or because we have a legitimate interest.
        </p>
      </div>

      <p><strong>Analysis of Personal Information to provide personalized services.</strong></p>
      <ul>
        <li>
          to better understand you so that we can personalize our interactions with you and provide you with information and/or offers tailored to your interests;
        </li>
        <li>
          to better understand your preferences so that we can deliver content via the Service that we believe will be relevant and interesting to you.
        </li>
      </ul>

      <p>
        We will provide personalized services either with your consent or because we have a legitimate interest.
      </p>
      <p>
        We also disclose information collected through the Service:
      </p>
      <ul>
        <li>
          to our affiliates for the purposes described in this Privacy Policy. A list of our affiliates is available at <a href="https://johnsonandjohnson.gcs-web.com/financial-information/sec-filings" target="_blank">https://johnsonandjohnson.gcs-web.com/financial-information/sec-filings</a>. Click on the link for Form 10K, Exhibit 21, under “SEC Filings”). Janssen Pharmaceuticals, Inc. is the party responsible for the management of the jointly used Personal Information;
        </li>
        <li>
          to our third-party partners with whom we offer a co‑branded or co‑marketed promotion;
        </li>
        <li>
          to our third-party service providers who provide services such as website hosting and moderating, mobile application hosting, data analysis, payment processing, order fulfillment, infrastructure provision, IT services, customer service, e‑mail and direct mail delivery services, auditing, and other services, in order to enable them to provide services; and
        </li>
        <li>
          as permitted by applicable law, to a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer, or other disposition of all or any portion of our business, assets, or stock (including in connection with any bankruptcy or similar proceedings).
        </li>
      </ul>
      <p>
        In addition, we may use and disclose your information as we believe to be necessary or appropriate: (a) to comply with legal process or applicable law which may include laws outside your country of residence; (b) as permitted by applicable law to respond to requests from public and government authorities, which may include authorities outside your country of residence; (c) to enforce our terms and conditions; and (d) to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or others. We may also use and disclose your information in other ways after obtaining your consent to do so.
      </p>
      <p>
        We may use and disclose information we collect automatically as described above under “Automatic Information Collection and Use.”
      </p>
      <p>
        In addition, where allowed by applicable law, we may use and disclose information that is not in personally identifiable form for any purpose. If we combine information that is not in personally identifiable form with information that is identifiable (such as combining your name with your geographical location), we will treat the combined information as personal information as long as it is combined.
      </p>
      <p>
        <strong class="upper">Choices and Access</strong>
      </p>
      <p>
        <strong>Your choices regarding our use and disclosure of your personal information </strong>
      </p>
      <p>
        We give you choices regarding our use and disclosure of your personal information for marketing purposes. You may opt out from:
      </p>
      <ul>
        <li>
          <strong>Receiving marketing communications from us:</strong> If you no longer want to receive marketing communications from us on a going‑forward basis, you may opt-out of receiving them by contacting us via 1-800-JANSSEN (526-7736) or send a written request to Janssen Medical Information, PO BOX 200 Titusville, NJ 08560. In your request to us, please provide your name, identify the form(s) of marketing communications that you no longer wish to receive, and include the address(es) to which it/they are sent. For example, if you no longer wish to receive marketing e‑mails or direct mail from us, tell us that, and provide your name and e‑mail or postal address. In addition, you may opt-out of receiving marketing e‑mails from us by following the unsubscribe instructions provided in any such message.
        </li>
        <li>
          <strong>Receiving reminders from us:</strong> If you no longer want to receive medical reminders from us on a going‑forward basis, you may opt-out of receiving them by contacting us via 1-800-JANSSEN (526-7736) or send a written request to Janssen Medical Information, PO BOX 200 Titusville, NJ 08560. In your response to us, please provide your name and the e‑mail address or phone number at which you receive reminders from us.
        </li>
        <li>
          <strong>Our sharing of your personal information with affiliates and third party partners:</strong> If you previously opted-in to receiving marketing communications from our affiliates or third party partners, you may opt-out of our sharing of your personal information with those parties for their direct marketing purposes on a going‑forward basis by contacting us via 1-800-JANSSEN (526-7736) or send a written request to Janssen Medical Information, PO BOX 200 Titusville, NJ 08560. In your communication to us, please state that we should no longer share your personal information with our affiliates and/or third‑party partners for their marketing purposes and include your name and e‑mail address.
        </li>
      </ul>
      <p>
        We will seek to comply with your request(s) as soon as reasonably practicable. Please note that if you opt-out as described above, we may not be able to directly remove your personal information from the databases of our affiliates with which we have already shared your information (i.e. as of the date that we implement your opt‑out request). However, we will make reasonable efforts to inform our affiliates of your request. Please also note that if you opt-out of receiving marketing‑related messages from us, we may still send you important transactional and administrative messages from which you cannot opt-out.
      </p>
      <p>
        <strong>How you can access, change, or delete your personal information</strong>
      </p>
      <p>
        If you would like to review, correct, update, restrict, or delete your personal information, or if you would like to request an electronic copy of your personal information for purposes of transmitting it to another company (to the extent these rights are provided to you by applicable law), please contact us via 1-800-JANSSEN (526-7736) or send a written request to Janssen Medical Information, PO BOX 200 Titusville, NJ 08560. We will respond to your request as soon as reasonably practicable and no later than one month after receipt. If circumstances cause any delay in our response, you will be promptly notified and provided a date for our response.
      </p>
      <p>
        <strong class="upper">Cross-border Transfer</strong>
      </p>
      <p>
        Your personal information may be stored and processed in any country where we have facilities or service providers, and by using our Service or by providing consent to us (where required by law), your information may be transferred to countries outside of your country of residence, including to the United States, which may provide for different data protection rules than in your country of residence. Nonetheless, appropriate contractual and other measures are in place to protect personal information when it is transferred to our affiliates or third parties in other countries.
      </p>
      <p>
        <strong class="upper">Security</strong>
      </p>
      <p>
        We seek to use reasonable organizational, technical, and administrative measures designed to protect personal information under our control. However, no data transmission over the Internet or data storage system can be guaranteed to be 100% secure. If you have reason to believe that your interaction with us is no longer secure (for example, if you feel that the security of any account you have with us has been compromised), please immediately notify us in accordance with the “Contacting Us” section below.
      </p>
      <p>
        <strong class="upper">Retention Period</strong>
      </p>
      <p>
        We will retain your personal information for as long as needed or permitted in light of the purpose(s) for which it was obtained. The criteria used to determine our retention periods include: (i) the length of time we have an ongoing relationship with you and provide the Service to you; (ii) whether there is a legal obligation to which we are subject; and (iii) whether retention is advisable in light of our legal position (such as, in regard to applicable statutes of limitations, litigation or regulatory investigations).
      </p>
      <p>
        <strong class="upper">Third Party Sites and Services</strong>
      </p>
      <p>
        This Service may contain links to sites of third parties. This Privacy Policy does not address, and we are not responsible for, the privacy, information, or practices of any third parties, including any third party operating any site or online service (including, without limitation, any application) that is available through this Service or to which this Service contains a link. The availability of, or inclusion of a link to, any such site or property on the Service does not imply endorsement of it by us or by our affiliates.
      </p>
      <p>
        <strong class="upper">Contacting Us</strong>
      </p>
      <p>
        Janssen Pharmaceuticals, Inc., located at 1125 Trenton-Harbourton Road, Titusville, NJ 08560, is the company responsible for collection, use, and disclosure of personal information under this Privacy Policy.
      </p>
      <p>
        If you have any questions about this Privacy Policy, please contact us via 1-800-JANSSEN (526-7736), or please write to the following address:
      </p>
      <p>
        Janssen Medical Information<br>
        PO Box 200<br>
        Titusville, NJ 08560
      </p>
      <p>
        <strong class="upper">Updates to This Privacy Policy</strong>
      </p>
      <p>
        We may change this Privacy Policy. Any changes to this Privacy Policy will become effective when we post the revised Privacy Policy on the Service. Your use of the Service following these changes means that you accept the revised Privacy Policy. We recommend that you regularly review the Privacy Policy when you visit the Service. This policy was last updated on November 2019.
      </p>
      <p id="pncr">
        <strong class="upper">Privacy Notice for California Residents</strong>
      </p>
      <p>
        Effective: January 1, 2020
      </p>
      <p>
        This Privacy Notice for California Residents supplements the information contained in the Johnson &amp; Johnson Global Privacy Policy (above), and applies only to California residents (“You,” “your” or “consumer”).
      </p>
      <p>
        <strong>Personal Information Collection and Purposes of Use</strong>
      </p>
      <p>
        We collect and use information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, to you or your devices when you visit this website, provide us your personal information, or have a contractual or business relationship with us or any of our affiliates, (“Personal Information”). Such Personal Information includes direct identifiers like a name, postal address, email address, social security number or other government identifier, and indirect identifiers that may identify, relate to, or be associated with a particular individual, such as a telephone number, device identifier, IP address and browsing history, credit card information, or inferences about consumer preferences or characteristics.
      </p>
      <p>
        We collect this Personal Information for the following purposes:
      </p>
      <ul>
        <li>to respond to your inquiries and to fulfill your requests;</li>
        <li>
          to send you important information regarding our relationship with you or regarding this website, changes to our terms, conditions, and policies and/or other administrative information;
        </li>
        <li>
          for audits, to verify that our internal processes function as intended and are compliant with legal, regulatory, or contractual requirements;
        </li>
        <li>
          for fraud or crime prevention, and for technical security monitoring purposes;
        </li>
        <li>to facilitate the development of new products and services; </li>
        <li>to enhance, improve or modify our website or products and services; </li>
        <li>for data analysis that will allow us to understand website usage trends;</li>
        <li>to determine the effectiveness of our promotional campaigns, so that we can adapt our campaigns to the needs and interests of our users. </li>
        <li>to better understand you, so that we can personalize our interactions with you and provide you with information and/or offers tailored to your interests; </li>
      </ul>

      <p><strong class="upper">Our Personal Information Handling Practices</strong></p>

      <p>In the preceding 12 months, we have collected the following categories of Personal Information from California residents who have visited this website, provided us their Personal Information, or had or have a contractual or business relationship with us or any of our affiliates:</p>
      <ul>
        <li>Direct identifiers as described above </li>
        <li>Indirect identifiers as described above.</li>
      </ul>
      <p>We have collected such Personal Information from one or more of the following categories of sources:</p>
      <ul>
        <li>Information that you submit or share directly with us, through registrations, surveys, applications, or telephone calls, and email and postal communications;</li>
        <li>Information passively collected from cookies and other website analytics;</li>
        <li>Information collected through third parties or from your browsing activity on other sites, such as on social media platforms, and public databases;</li>
        <li>From one or more of our affiliates with which you have a business relationship; </li>
        <li>Service providers with which we have a contractual relationship and to which you have provided your Personal Information </li>
      </ul>

      <p>We collected such Personal Information for the purposes noted above (see “Personal Information Collection and Purposes of Use”) and in the J&J Global Privacy Policy (see “How We Use and Disclose Information”):</p>
      <p>
        We may have shared such Personal Information with the following categories of third parties:
      </p>

      <ul>
        <li>
          Service providers that help us to run our business, such as call centers and order fulfillment and distribution companies, credit card processing companies, web hosting and development companies, and direct marketing agencies
        </li>
        <li>Vendors that help us track the effectiveness of advertisements on our Sites</li>
        <li>
          Vendors that help us to provide you with program, services or educational information we believe may be of interest to you
        </li>
        <li>Third parties with which we jointly market a product </li>
        <li>
          Affiliates and subsidiaries that may have or may want to seek a business relationship with you
        </li>
      </ul>
      <p>
        We collected one or more of the following specific pieces of personal information:
      </p>
      <ul>
        <li>
          Legal name, nickname, signature, email address, postal address, social security number, date of birth, driver’s license number, physical characteristics or description, educational level, current employment or employment history, biometric information, and/or geolocation data
        </li>
        <li>
          Account name, bank account number, credit card number, debit card number, or any other financial information, medical information and/or health insurance information
        </li>
        <li>
          Online identifier, Internet Protocol address, Internet or other electronic network activity information, including, but not limited to, browsing history, search history, and information regarding a consumer’s interaction with an Internet Web site, application, or advertisement
        </li>
      </ul>
      <p>
        Unless specifically stated, we do not share, disclose or sell personal information to third parties for their own use, but we do share your personal information with our affiliates and trusted partners in arrangements that may meet the broad definition of “sale” under California law. In these arrangements, use of the information we share is limited by policies, contracts, or similar restrictions.
      </p>
      <p>
        In the preceding 12 months we may have disclosed, shared or sold, as defined by California law, one or more of the above categories of personal information.
      </p>
      <p>
        <strong>Your Privacy Rights </strong>
      </p>
      <p>
        You have the following rights regarding our collection and use of your personal information. To exercise those rights, you must submit a request by either calling us at 1-800-JANSSEN (526-7736) or through <a href="https://www.janssen.com/us/privacy-request" target="_blank">https://www.janssen.com/us/privacy-request</a>. We may ask you to provide additional information to verify your request. We may not discriminate against you if you exercise your rights as described in this notice. For example, we may not deny goods or services to you, or charge you different prices or rates, or provide a different level of quality of products or services.
      </p>
      <p>
        <u>Right to Information </u>
      </p>
      <p>You have the right to request the following information regarding the personal information we have collected about you:</p>
      <ul>
        <li>
          Categories of personal information collected about you, and sources from which collected;
        </li>
        <li>
          Our purpose for collecting personal information;
        </li>
        <li>
          Categories of third parties with which the personal information was shared; and
        </li>
        <li>
          Specific pieces of personal information collected about consumers.
        </li>
      </ul>

      <p>You have the right to request the following information regarding the personal information we have sold or disclosed about you:</p>
      <ul>
        <li>
          Categories of your personal information sold in the preceding 12 months;
        </li>
        <li>
          Categories of third parties to whom your personal information has been disclosed;
        </li>
        <li>
          Categories of personal information that we disclosed about consumers for a business purpose.
        </li>
      </ul>

      <p>
        <u>Right to Opt Out of Sharing, Disclosure, or Sale of Personal Information</u>
      </p>
      <p>
        You have the right to direct us to not share, disclose, or sell your personal information. To exercise this right, you or your authorized representative may submit a request by clicking on the following link:<br>
        <strong>
          <a href="https://www.janssen.com/us/privacy-request/" target="_blank">Do Not Sell My Personal Information </a>
        </strong>
      </p>

      <p>
        <u>Right to Request Deletion</u>
      </p>
      <p>You have the right to request that we delete the personal information we have about you. However, we are not required to delete information if it is necessary to retain your information to: </p>
      <ul>
        <li>
          Complete the transaction for which the personal information was collected, provide a good or service requested by you, or a transaction reasonably anticipated within the context of our or one of our affiliate’s ongoing business relationship with you, or to otherwise perform a contract we have with you.
        </li>
        <li>
          Detect security incidents, protect against malicious, deceptive, fraudulent or illegal activity or prosecute those responsible for that activity.
        </li>
        <li>
          Debug to identify and repair errors that impair existing intended functionality.
        </li>
        <li>
          Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided for by law.
        </li>
        <li>
          Comply with the California Electronic Communications Privacy Act pursuant to Chapter 3.6 (commencing with Section 1546) of Title 12 of Part 2 of the Penal Code.
        </li>
        <li>
          Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when deletion of the information is likely to render impossible or seriously impact the achievement of such research, if you have provided informed consent.
        </li>
        <li>
          Facilitate solely internal uses that are reasonably aligned with your expectations based on your relationship with us or one of our affiliates.
        </li>
        <li>
          Comply with a legal obligation.
        </li>
        <li>
          Otherwise use the personal information, internally, in a lawful manner that is compatible with the context in which it was provided.
        </li>
      </ul>

      <p><strong class="upper">Contact Us </strong></p>
      <p>
        You can contact us with questions about this Privacy Notice for California Residents or to exercise your rights as described in this Notice.
      </p>
      <p>Telephone number: 1-800-JANSSEN (526-7736)<br>
        Email or web address: <a href="https://www.janssen.com/us/privacy-request" target="_blank">https://www.janssen.com/us/privacy-request</a> <br>
        Postal address: Janssen Medical Information, PO Box 200, Titusville, NJ 08560 <br>
        Contact Title: Privacy Manager
      </p>

      <p id="pnnr">
        <strong class="upper">Supplemental Privacy Notice for Nevada Residents</strong>
      </p>
      <p>
        Effective: October 1, 2019
      </p>
      <p>
        This Supplemental Privacy Notice for Nevada Residents adds to the information contained in the Johnson & Johnson Global Privacy Policy (above), and applies only to Nevada residents (“You,” “your” or “consumer”).
      </p>
      <p>
        <strong class="upper">Personal Information Collection and Purposes of Use</strong>
      </p>
      <p>
        We collect certain personal information of Nevada consumers through our Internet websites or other online service. This information includes one or more of the following elements of personally identifiable information:
      </p>
      <ol>
        <li>
          A first and last name.
        </li>
        <li>
          A home or other physical address that includes the name of a street and the name of a city or town.
        </li>
        <li>
          An electronic mail address.
        </li>
        <li>
          A telephone number.
        </li>
        <li>
          A Social Security Number.
        </li>
        <li>
          An identifier that allows a specific person to be contacted either physically or online.
        </li>
        <li>
          Any other information concerning a person collected from the person through the Internet website or online service of the operator, and maintained by the operator in combination with an identifier in a form that makes the information personally identifiable.
        </li>
      </ol>

      <p>We collect this personal information for the following purposes: </p>
      <ul>
        <li>to respond to your inquiries and to fulfill your requests;</li>
        <li>to send you important information regarding our relationship with you or regarding this website, changes to our terms, conditions, and policies and/or other administrative information; </li>
        <li>for audits, to verify that our internal processes function as intended and are compliant with legal, regulatory, or contractual requirements; </li>
        <li>for fraud or crime prevention, and for technical security monitoring purposes; </li>
        <li>to facilitate the development of new products and services; </li>
        <li>to enhance, improve or modify our website or products and services;</li>
        <li>for data analysis that will allow us to understand website usage trends;</li>
        <li>to determine the effectiveness of our promotional campaigns, so that we can adapt our campaigns to the needs and interests of our users. </li>
        <li>to better understand you, so that we can personalize our interactions with you and provide you with information and/or offers tailored to your interests. </li>
      </ul>
      <p>
        <strong class="upper">
          Your Privacy Rights
        </strong>
      </p>
      <p>
        <u>Right to access and/or correct your personal information, or opt out of sale of personal information</u>
      </p>
      <p>
        If you would like to review, correct, or update your personal information, you or your authorized representative may submit your request to <a href="https://www.janssen.com/us/privacy-request" target="_blank"> https://www.janssen.com/us/privacy-request</a>. We will respond to your verified request as soon as reasonably practicable, but no later than sixty (60) days after receipt. If circumstances cause any delay in our response, you will be promptly notified and provided a date for our response.
      </p>
      <p>
        We generally do not disclose or share personal information for profit. Under Nevada law, you have the right to direct us to not sell or license your personal information to third parties. To exercise this right, if applicable, you or your authorized representative may submit a request to <a href="https://www.janssen.com/us/privacy-request" target="_blank"> https://www.janssen.com/us/privacy-request</a>. We will respond to your verified request as soon as reasonably practicable, but no later than sixty (60) days after receipt. If circumstances cause any delay in our response, you will be promptly notified and provided a date for our response.
      </p>

      <p>
        <strong class="upper">Contact Us </strong>
      </p>
      <p>
        You can contact us with questions about this Privacy Notice for Nevada Residents or to exercise your rights as described in this Notice.
      </p>
      <p>
       Via web: <a href="https://www.janssen.com/us/privacy-request" target="_blank"> https://www.janssen.com/us/privacy-request</a>
      </p>

    </div>




  </div>

</template>

<style scoped>

#app > div {
  width: 100%;
  }

/*TOP */

  .top-wrap{
    background: rgb(0,18,82);
    background: linear-gradient(0deg, rgba(0,18,82,1) 0%, rgba(0,70,126,1) 50%, rgba(0,70,126,1) 100%);
    color: #ffffff;
    padding-bottom: 60px;
    width: 100%;
  }
  .top-content{
    background: linear-gradient(to top, #0079A8, #0084B8);
    border-radius: 0 0 0 100px;
    margin-left: 3%;
    padding-bottom: 50px;
    width: 97%;
  }
  .top-banner{
    background: url(../img/banner-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  header{
    margin-left: 75px;
  }

  header .logo{
    margin: 47px 0 0 0;
  }

  header a{
    color: #424242;
    font-family: "GothamBook", sans-serif;
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    text-decoration: none;
  }
  header ul{
    display: inline-block;
    margin: 86px 0 0 54px;
    position: absolute;
  }
  header li{
    display: inline-block;
    margin-right: 52px;
    vertical-align: top;
  }


.top-banner h1{
  display: block;
  font-size: 38px;
  font-family: "GothamBook", sans-serif;
  color: #ffffff;
  font-weight: bold;
  line-height: 1.211;
  text-align: center;
  max-width:1121px;
  margin: 68px auto 42px auto;

}

.top-banner h1 span{
  display: block;
  font-family: "GothamBook", sans-serif;
  font-weight: 400;
}

.top-banner .super {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-top;
}

.top-banner section{
  color: #ffffff;
  font-size: 18px;
  font-family: "GothamBook", sans-serif;
  font-weight: 500;
  line-height: 1.333;
  margin: 0 auto;
  max-width: 1030px;
  text-align: center;
}

.top-content p.banner-footer{
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
}



.home-body{
  color: #363636;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 14px;
  line-height: 20px;
  margin: 50px auto 0 auto;
  width: 1121px;
}

.footer-references span{
  word-break: break-all;
}


.body{
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  margin: 59px auto 0 auto;
  line-height: 17px;
  padding-bottom: 30px;
  position: relative;
  width: 90%;
}

.body a{
  word-break: break-all;
}

.body .references{
  display: block;
  font-family: acumin-pro, sans-serif;
  font-size: 14px;
  margin: 0;
  width: 1121px;
}

.subhead{
  font-size: 20px;
  font-weight: bold;
  line-height: 22px;
}

.body ul{
  list-style: disc;
  margin-left: 17px;
}
.body ul li{
  padding-top: 6px;
}

.top-link{
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: 0px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 115px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}

.site-guide, #menuToggle, #boton, .home{
  display: none;
}

.upper{
  text-transform: uppercase;
}

.indent{
  padding-left: 25px;
}

.indent p:first-child{
  margin-top: 0;
}
.indent p:last-child{
  margin-bottom: 0;
}

.body .indent ul{
  margin-left: 15px;
}

@supports (-webkit-touch-callout: none) {
  .resources > div button{
    line-height: 65px;
  }
}


@media screen and (max-width: 1024px){
  header{
    margin-left: 25px;
  }

  .top-banner section{
    max-width: 95%;
  }

  footer img{
    left: 78%;
  }

  header{
    margin-left: 25px;
  }

  header li {
    margin-right: 35px;
    width: min-content;
  }

  .top-banner *, .body * {
    max-width: 95%;
  }

  .home-body{
    max-width: 95%;
  }
}

@media screen and (max-width: 880px){

  header{
    margin-left: 7%;
  }

  header ul{
    display: block;
    margin: 0;
  }

  header li{
    margin: 0;
  }


  .top-banner{
    background: url(../img/banner-mobile2-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: "GothamBook", sans-serif;
    font-size: 20px;
    line-height: 30px;
    font-weight: 100;
    width: 84%;
  }
  .top-banner section p{
    line-height: 20px;
  }

  .top-banner .super {
    font-size: 8px;
    font-weight: 100;
    margin: 0 0 0 2px;
    vertical-align: text-top;
}

  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .home-body{
    width: 87%;
  }

  #boton{
    height: 36px;
    position: absolute;
    cursor: pointer;
    opacity: 0;
    right: 53px;
    top: 55px;
    width: 50px;
    z-index: 100000;
  }

  .menu {
    border-radius: 0 0 0 100px;
    padding: 108px 58px 50px 58px;
    position: absolute;
    top:0px;
    left:0px;
    background: #00a0df;
    transition:all 0.5s;
    transform:translatex(-100%);
  }

  .menu li{
    border-bottom: 2px solid #ffffff;
    font-size: 24px;
    height: 146px;
    line-height: 146px;
    width: 100%;
  }

  .menu a {
    color: #ffffff;
    display :block;
    font-family: "GothamBook", sans-serif;
    font-size: 24px;
    height: 146px;
    line-height: 146px;
    padding: 0 80px 0 133px;
    white-space: nowrap;
  }

  .menu .active a{
    color:#001252;
    font-weight: bold;
  }

  .menu a br {
    display: none;
  }

  #boton:checked ~ .menu{
    transform: translatex(0%);
  }

  #menuToggle{
    height: 36px;
    position: absolute;
    right: 53px;
    top: 55px;
    width: 50px;
    z-index: 1;
  }

  header input ~ #menuToggle{
    background: url(../img/icon-menu.png) no-repeat center center;
    background-size: cover;
  }

  header input:checked ~ #menuToggle{
    background: url(../img/icon-menu-close.png) no-repeat center center;
  }

  .site-guide, #menuToggle, #boton, .home{
    display: block;
  }

  .home a{
    background: url(../img/icon-menu-home.png) no-repeat left center;
  }
  .population-identification{
    background: url(../img/icon-menu-glass.png) no-repeat left center;
  }
  .expanding-capabilities{
    background: url(../img/icon-menu-expanding.png) no-repeat left center;
  }
  .collaborative-care{
    background: url(../img/icon-menu-hands.png) no-repeat left center;
  }
  .process-evaluation{
    background: url(../img/icon-menu-process.png) no-repeat left center;
  }
  .resource-library{
    background: url(../img/icon-menu-resources.png) no-repeat left center;
  }
  .site-guide{
    background: url(../img/icon-menu-book.png) no-repeat left center;
  }
  .menu li.site-guide{
    border: 0;
  }
  .menu li a{
    position: relative;
  }
  .menu li a::after{
    content: '>';
    color: #0f3765;
    font-size: 29px;
    font-weight: bold;
    position: absolute;
    right: 0;
  }

}

@media screen and (max-width: 540px){

  .menu{
    padding: 100px 20px 50px 20px;
    width: calc(100% - 40px);
    overflow: hidden;
  }

  .menu li{
    height: 96px;
    line-height: 96px;
  }

  .menu a{
    font-size: 22px;
    height: 96px;
    line-height: 96px;
    padding: 0 20px 0 100px;
  }

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 21px auto;
  }

  .top-banner h1 span{
    display: block;
    font-size: 19px;
    line-height: 23px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

}

@media screen and (max-width: 320px){

  footer li[data-v-40ab164b]:nth-child(2n){
    width: 42%;
  }
}


/* new styles sergio */

@media screen and (max-width: 880px){
    #boton {
      right: 25px;
      top: 35px;
      z-index: 10000;
    }
    header input ~ #menuToggle{
      width: 40px;
      height: 27px;
      right: 40px;
      top: 45px;
      background-size: cover;
    }
    header input:checked~#menuToggle{
        width: 28px;
        height: 28px;
        right: 40px;
        top: 45px;
        background-size: cover;
        z-index: 1000;
    }
    .menu{
      padding-top: 60px;
      padding-left: 30px;
      padding-right: 30px;
      border-radius: 0 0 0 50px;
      height: 580px;
      min-width: 100%;
      width: 100%;
      box-sizing: border-box;
      z-index: 100;
    }
    .menu a{
      height: 70px;
      line-height: 78px;
      padding-left: 60px;
    }
    .menu li{
      height: 70px;
      border-bottom-width: 1px;
    }

    .menu li a{
      font-weight: 400;
      line-height: 70px;
    }

    .menu li a:after{
        font-size: 18px;
    }

    .home a{
        background-size: 38px auto;
    }
    .population-identification{
        background-size: 37px auto;
    }
    .expanding-capabilities, .collaborative-care{
        background-size: 35px auto;
    }

    .process-evaluation, .resource-library{
      background-size: 31px auto;
    }

    .site-guide{
      background-size: 33px auto;
    }

    .top-banner header .logo img{
      width: 60%;
    }

}

@media screen and (max-width: 600px){
    .menu a{
        font-size: 12px;
        padding-left: 60px;
    }
}

@media screen and (max-width: 415px){
  header{
    margin-left: 30px;
  }

  header .logo{
    margin: 23px 0 0 0;
  }

  header input:checked~#menuToggle{
    width: 28px;
    height: 28px;
    right: 20px;
    top: 23px;
    background-size: cover;
  }

  header input ~ #menuToggle {
    right: 20px;
    top: 23px;
  }

  #boton {
    right: 13px;
    top: 16px;
  }

  .top-wrap{
    padding-bottom: 20px;
  }

  .top-content{
    padding-bottom: 28px;
  }

  .menu{
    padding-left:15px;
    padding-right:15px;
  }
  .menu a{
    padding-left: 45px;
  }

   @supports (-webkit-touch-callout: none) {
    .filter-list span{
      line-height: 32px;
    }

    .filter-content .apply{
      line-height: 70px;
    }

    .top-link{
      padding-top: 12px;
    }

  }

}

</style>

<script>
export default {
  mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },


    },
}
</script>



// WEBPACK FOOTER //
// src/components/Privacy_Policy.vue